import { DeleteOutlined, DownloadOutlined, DownOutlined, EditOutlined, EyeOutlined, PlusOutlined, SearchOutlined, UploadOutlined } from '@ant-design/icons';
import { Breadcrumb, ConfigProvider, Input, Pagination, Select, Switch } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import * as categoryCarApi from '../../../api/categoryCar/categoryCarApi';
import * as typeVehicleApi from '../../../api/typeVehicle/typeVehicleApi';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import useDebounce from '../../../hook/useDebounce';
import useToast from '../../../hook/useToast';
import Layout from '../../../Layout';
import ModalCreateBrand from './Component/Modal/ModalCreateBrand';
import ModalEditBrand from './Component/Modal/ModalEditBrand';
import './style.scss';

import viVN from 'antd/locale/vi_VN';
import { API_URL, URL_CAR_CATEGORY } from '../../../env';
import useThrottle from '../../../hook/useThrottle';

import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { PaginationProps } from 'antd/es/pagination/Pagination';
import { useSelector } from 'react-redux';
import { getCLCarLines, getCLTypeVehicle } from '../../../api/selectOption/selectOptionsApi';
import { avatarDefault, noData } from '../../../components/ExportImgFigma';
import useLoading from '../../../hook/useLoading';
import { selectorMenu } from '../../../store/slices/menuSlice';
import { checkDisabledPermission, dataPagination, findChildIdByUrl, fommatSelectOption, getUserPermissions } from '../../../until';
import ImportDataColorCar from '../../Customers/Component/ImportDataModal/ImportDataColorcar';
import StatusCellRenderer from '../VehicleTypeManagement/Component/StatusCellRenderer';
import ModalViewBrand from './Component/Modal/ModalViewBrand';
import { NodataTable } from '../../../components/NoDataTable';
import { NO_DATA } from '../../../services/data';
import { formatNumber } from '../../../services/mixin';
import { useLocation } from 'react-router-dom';
import { selectorPermission } from '../../../store/slices/permissionSlice';
import { activeArray } from '../../../api/unit/unitApi';

interface IDataDefaulFilterList {
  carLineId?: number
  typeVehicleId?: number
  search: string;
}
const dataDefaulFilterList = {
  search: "" as string, // Thêm trường search
  carLineId: undefined,
  typeVehicleId: undefined
};


const BrandManagement_V2: React.FC = () => {
  useEffect(() => {

    return () => {
      setDataFilterList(dataDefaulFilterList)
      setPagination({ current: 1, pageSize: 20, total: 0 })
      setSelectedRowKeys([])
    }
  }, [])



  const pushToast = useToast();
  const pushLoading = useLoading()
  const location = useLocation();
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, download, upload } = getUserPermissions(permissionSlice, location.pathname)


  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isModalBrandCreate, setIsModalBrandCreate] = useState<boolean>(false)
  const [isModalBrandUpdate, setIsModalBrandUpdate] = useState<boolean>(false)
  const [isModalBrandDelete, setIsModalBrandDelete] = useState<boolean>(false)
  const [openModalUpload, setOpenModalUpload] = useState(false);

  // bộ lọc
  const [fileData, setFileData] = useState({} as any)
  const [filterCarLines, setFilterCarLines] = useState<{ value: number, label: string }[]>([])
  const [filterTypeVehicle, setFilterTypeVehicle] = useState<any[]>([])

  const [type, setType] = useState<string>("")

  const [isOpenModalAdd, setIsOpenModalAdd] = useState(false)
  const [isOpenModalView, setIsOpenModalView] = useState(false)
  const [isOpenModalEdit, setIsOpenModalEdit] = useState(false)
  const [isModalDelete, setIsModalDelete] = useState(false)

  const [dataFilterList, setDataFilterList] = useState<IDataDefaulFilterList>(dataDefaulFilterList)

  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  const [idChose, setIdChose] = useState<number[]>();

  const [infoCategoryCar, setInfoCategoryCar] = useState<categoryCarApi.ICategoryCar>()

  const [listCategoryCar, setListCategoryCar] = useState<categoryCarApi.ICategoryCar[]>([])


  const actionColumn: ColDef = {
    headerName: 'Hành động',
    headerComponentParams: {
      template: '<span class="w-full flex items-center justify-center">Hành động</span>'
    },
    field: 'action',
    colId: 'action',
    width: 180,
    resizable: false,
    suppressMovable: true,
    lockPosition: 'left',
    // width: getWidthFromHeader('Hành động'),
    cellRenderer: (params: any) => {
      const id = params.data.id
      // const { view, edit, delete: isDelete } = params?.data?.permissionMenu
      return (
        <div className='d-flex gap-4 justify-start align-center  h-full'>

          <EyeOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
            onClick={() => gInfoCarLine(id)}
          />
          <EditOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(edit)}`}
            onClick={() => gInfoCarLine(id, false)}
          />
          <DeleteOutlined
            className={`text-F5222D text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(isdelete)}`}
            onClick={() => openModalDelete(Number(id))}
          />

        </div>

      )
    },
  }


  const columnDefs = useMemo<ColDef<categoryCarApi.ICategoryCar>[]>(() => [
    actionColumn,
    {
      headerName: "Dòng xe",
      field: "carLineTitle",
      sortable: true,
      flex: 1,
      valueFormatter: (params) => params.value ?? NO_DATA,
    },
    {
      headerName: "Loại xe",
      field: "typeVehicleTitle",
      sortable: true,
      flex: 1,
      valueFormatter: (params) => params.value ?? NO_DATA,
    },
    {
      headerName: "Mã thương hiệu",
      field: "code",
      sortable: true,
      flex: 1,
      valueFormatter: (params) => params.value ?? NO_DATA,
    },
    {
      headerName: "Logo",
      field: "image",
      autoHeight: true,
      cellRenderer: (params: ICellRendererParams) => {
        if (!params.value) {
          return (
            <div className="!h-full w-full d-flex align-center justify-center">
              {NO_DATA}
            </div>
          );
        }
        const src = `${URL_CAR_CATEGORY}${params.value}`; // nhớ đảm bảo có dấu "/"
        return (
          <div className="!h-full w-full d-flex align-center justify-center">
            <img
              src={src}
              alt="logo"
              style={{ maxWidth: '35px', maxHeight: '35px', objectFit: 'cover' }}
              onError={(e) => {
                e.currentTarget.src = avatarDefault;
              }}
            />
          </div>
        );
      },
      flex: 1,
    },
    {
      headerName: "Thương hiệu",
      field: "title",
      sortable: true,
      flex: 1,
      valueFormatter: (params) => params.value ?? NO_DATA,
    },
    // {
    //   headerName: "Trạng thái",
    //   field: "status",
    //   sortable: true,
    //   cellRenderer: StatusCellRenderer,
    //   cellRendererParams: {
    //     onToggle: (id: number, isActive: boolean) => uActiveCategoryCar(id, isActive),
    //     idKey: 'id',
    //   },
    //   minWidth: 200
    // },
    {
      headerName: "Trạng thái",
      field: "status",
      sortable: true,
      cellRenderer: (params: ICellRendererParams) => {
        const { id, status } = params.data;
        return (
          <div className="d-flex align-center gap-10-px">
            <Switch
              defaultChecked={!!status}
              onChange={() => uActiveCategoryCar(Number(id))}
              className={`rs-switch rs-switch--sm   ${checkDisabledPermission(edit)}`}
            />
            <p className="font-medium fw-500 text-344054">
              {activeArray[status ? 1 : 0]}
            </p>
          </div>
        );
      },
      minWidth: 200
    },
  ], [pagination]);


  const gListCategoryCar = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const { carLineId, typeVehicleId, search } = dataFilterList

    const result = await categoryCarApi.getListCategoryCar(
      pageSize, pageCurent, carLineId, typeVehicleId,
      search
    )
    if (result?.status) {
      setListCategoryCar(result.data)
      setPagination({ current: pageCurent, total: result.total, pageSize })
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const gListCarLine = useDebounce(async () => {
    pushLoading(true)
    const result = await getCLCarLines()
    if (result?.status) {
      setFilterCarLines(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)



  const gListTypeVehicle = useDebounce(async () => {
    pushLoading(true)
    const { carLineId } = dataFilterList

    const result = await getCLTypeVehicle(carLineId)
    if (result?.status) {
      setFilterTypeVehicle(fommatSelectOption(result.data))
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const gInfoCarLine = useThrottle(async (id: number, isview: boolean = true) => {
    pushLoading(true)
    const result = await categoryCarApi.getInfoCategoryCar(
      id
    )
    if (result?.status) {
      setInfoCategoryCar(result.data)
      if (isview)
        setIsOpenModalView(true)
      else
        setIsOpenModalEdit(true)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const uActiveCategoryCar = useThrottle(async (id: number, isActive: boolean) => {
    pushLoading(true)
    const result = await categoryCarApi.updateActiveCategoryCar(
      id
    )
    if (result?.status) {
      gListCategoryCar(pagination.current, pagination.pageSize)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const onSubmitFormModalAdd = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setIsOpenModalAdd(false)
      pushToast(message, "success")
      gListCategoryCar(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "error")
    }
  }

  const onSubmitFormModalEdit = (iSsuccess: boolean, message?: string) => {
    if (iSsuccess) {
      setIsOpenModalEdit(false)
      pushToast(message, "success")
      gListCategoryCar(pagination.current, pagination.pageSize)
    } else {
      pushToast(message, "error")
    }
  }

  const onSubmitFormModalDelete = async () => {
    if (!idChose) return
    const result = await categoryCarApi.deleteCategoryCar(idChose)
    if (result.status) {
      setIsModalDelete(false)
      pushToast(result.message, "success")
      gListCategoryCar(pagination.current, pagination.pageSize)
    } else {
      pushToast(result.message, "error")
    }
  }

  const openModalDelete = (id: number) => {
    setIdChose([id])
    setIsModalDelete(true)
  }

  const closeModalDelete = () => {
    setIdChose(undefined)
    setIsModalDelete(false)
  }

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gListCategoryCar(pageNumber, pageSize)
  }

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const handleUpload = async (type: string): Promise<typeVehicleApi.ResponseSuccessDataError> => {
    setType(type)
    const result = await typeVehicleApi.uploadFileCategoryCar(fileData)
    if (result?.status) {
      pushLoading(true)
    }
    return result
  }
  const handleFile = (file: any) => {
    setFileData(file)
  }

  useEffect(() => {
    gListCategoryCar()
    gListTypeVehicle()
  }, [dataFilterList])

  useEffect(() => {
    gListCarLine()
  }, [])

  return (

    <Layout>
      <ImportDataColorCar
        show={openModalUpload}
        fileData={fileData}
        linkExamplPre={`${API_URL}uploads/fileExcel/car/Danhsachthuonghieu.xlsx`}
        type={"dataCategoryError"}

        setFileData={setFileData}
        handleUpload={() => handleUpload(type)}
        handleFile={handleFile}
        gListCarColor={gListCategoryCar}
        modalClose={() => setOpenModalUpload(false)}
      />

      <ModalCreateBrand
        isOpen={isOpenModalAdd}
        onSubmitFormModal={onSubmitFormModalAdd}
        closeModal={() => setIsOpenModalAdd(false)}
      />

      <ModalViewBrand
        isOpen={isOpenModalView}
        infoCategoryCar={infoCategoryCar}
        closeModal={() => setIsOpenModalView(false)}
      />

      <ModalEditBrand
        isOpen={isOpenModalEdit}
        infoCategoryCar={infoCategoryCar}
        onSubmitFormModal={onSubmitFormModalEdit}
        closeModal={() => setIsOpenModalEdit(false)}
      />

      <ModalDeleteManager
        isOpen={isModalDelete}
        title="Bạn có chắc chắn xóa thương hiệu này"
        titleDelete="Xóa thương hiệu"
        content="Thương hiệu và dữ liệu liên quan sẽ bị xóa vĩnh viễn
      không thể khôi phục"
        onConfirm={onSubmitFormModalDelete}
        closeModal={closeModalDelete}
      />

      <Breadcrumb
        items={[
          {
            title: 'THACO AUTO CRM',
          },
          {
            title: <a href="/">Quản lý danh mục xe</a>,
          },
          {
            title: 'Quản lý thương hiệu xe',
          },
        ]}
      />
      <div className='title-page'>
        Quản lý thương hiệu xe
      </div>
      <div className='d-flex gap-3 pb-18-px brand-management-filter'>
        <div className="w-full border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3  py-1 h-8 justify-between overflow-hidden">
          <Input
            placeholder="Tìm kiếm theo thương hiệu xe"
            className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
            value={dataFilterList.search}
            onChange={(e) => setDataFilterList({ ...dataFilterList, search: e.target.value })}
          />
          <div className=" border-l-F2F4F7 h-full d-flex align-center">
            <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
          </div>
        </div>
        <div className='d-flex align-center gap-2'>
          <div className="w-200-px border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
            <div className="d-flex align-center  w-full">
              <Select
                showSearch
                allowClear
                className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                popupClassName='position-dropdow custome-select-item h-popUp'
                variant="borderless"
                placeholder="Chọn dòng xe"
                suffixIcon={null}
                options={filterCarLines}
                value={dataFilterList.carLineId}
                onChange={(e) => setDataFilterList({ ...dataFilterList, carLineId: e })}
              />

            </div>
            <div className="  h-full d-flex align-center">
              <DownOutlined className="text-sm text-98A2B3 " />
            </div>
          </div>
        </div>
        <div className='d-flex align-center gap-2'>
          <div className="w-200-px border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center px-3  py-2-px h-8 justify-between overflow-hidden">
            <div className="d-flex align-center  w-full">
              <Select
                showSearch
                allowClear
                className="w-full  text-left text-span-select text-sm  bg-FCFCFD-ant-select font-regular p-none-select h-8 line-none line-none-item inline-none size-selector "
                popupClassName='position-dropdow custome-select-item h-popUp'
                variant="borderless"
                placeholder="Chọn loại xe"
                suffixIcon={null}
                options={filterTypeVehicle}
                value={dataFilterList.typeVehicleId}
                onChange={(e) => setDataFilterList({ ...dataFilterList, typeVehicleId: e })}
              />

            </div>
            <div className="  h-full d-flex align-center">
              <DownOutlined className="text-sm text-98A2B3 " />
            </div>
          </div>
        </div>
        <button
          className={`border-EAECF0 bg-white rounded-6-px w-106-px py-2 px-4 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save ${checkDisabledPermission(download)}`}
        // onClick={selectedRowKeys.length ? glistSelectedExel : glistByExcel}
        >
          <DownloadOutlined className='text-sm text-344054' />
          <span className='text-sm fw-400 font-regular text-344054 white-space-nowrap'>Xuất DS</span>
        </button>
        <button
          className={`border-EAECF0 bg-white rounded-6-px w-111-px py-2 px-4 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save ${checkDisabledPermission(upload)}`}
          onClick={() => setOpenModalUpload(true)}
        >
          <UploadOutlined className='text-sm text-344054' />
          <span className='text-sm fw-400 font-regular text-344054 white-space-nowrap'>Nhập DS</span>
        </button>
        <button className={`border-none bg-096DD9 rounded-6-px  py-2 px-4 h-8 d-flex justify-center align-center gap-10-px w-107-px ${checkDisabledPermission(add)}`}
          onClick={() => setIsOpenModalAdd(true)}
        >
          <PlusOutlined className='text-sm text-white' />
          <span className='text-sm fw-400 font-regular text-white white-space-nowrap'>Tạo mới</span>
        </button>
      </div>
      <div className="t-table-block  custom-page-css flex flex-col flex-1 justify-between" >
        <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 610 }}>
          <AgGridReact
            rowSelection="multiple"
            rowData={listCategoryCar}
            columnDefs={columnDefs}
            className="my-auto-height-grid"
            rowHeight={55}
            getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            overlayNoRowsTemplate={NodataTable}
            suppressDragLeaveHidesColumns={true}
          />

        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination
              showSizeChanger
              pageSize={pagination.pageSize}
              total={pagination.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize, pagination.current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}

            />
          </div>
        </ConfigProvider>
      </div>
    </Layout>

  );
}

export default BrandManagement_V2;
